import { baseApiClient as api } from "../baseService";

export const addTagTypes = ["deliverables", "deliverable_matches"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      matterDeliverablesList: build.query<
        MatterDeliverablesListApiResponse,
        MatterDeliverablesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/`,
        }),
        providesTags: ["deliverables"],
      }),
      matterDeliverablesRetrieve: build.query<
        MatterDeliverablesRetrieveApiResponse,
        MatterDeliverablesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/${queryArg.id}/`,
        }),
        providesTags: ["deliverables"],
      }),
      matterDeliverablesBatchCreate: build.mutation<
        MatterDeliverablesBatchCreateApiResponse,
        MatterDeliverablesBatchCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/batch_create/`,
          method: "POST",
          body: queryArg.createDeliverable,
        }),
        invalidatesTags: ["deliverables"],
      }),
      matterDeliverablesPending: build.query<
        MatterDeliverablesPendingApiResponse,
        MatterDeliverablesPendingApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/pending/`,
        }),
        providesTags: ["deliverables"],
      }),
      matterDeliverablesScan: build.mutation<
        MatterDeliverablesScanApiResponse,
        MatterDeliverablesScanApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/scan/`,
          method: "POST",
        }),
        invalidatesTags: ["deliverables"],
      }),
      matterDeliverablesScanStatus: build.query<
        MatterDeliverablesScanStatusApiResponse,
        MatterDeliverablesScanStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/scan-status/`,
        }),
        providesTags: ["deliverables"],
      }),
      matterDeliverablesSummary: build.query<
        MatterDeliverablesSummaryApiResponse,
        MatterDeliverablesSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/deliverables/summary/`,
        }),
        providesTags: ["deliverables"],
      }),
      taskDeliverablesList: build.query<
        TaskDeliverablesListApiResponse,
        TaskDeliverablesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/`,
        }),
        providesTags: ["deliverables"],
      }),
      taskDeliverablesCreate: build.mutation<
        TaskDeliverablesCreateApiResponse,
        TaskDeliverablesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/`,
          method: "POST",
          body: queryArg.createDeliverable,
        }),
        invalidatesTags: ["deliverables"],
      }),
      deliverableMatchesList: build.query<
        DeliverableMatchesListApiResponse,
        DeliverableMatchesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/`,
        }),
        providesTags: ["deliverable_matches"],
      }),
      deliverableMatchesCreate: build.mutation<
        DeliverableMatchesCreateApiResponse,
        DeliverableMatchesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/`,
          method: "POST",
          body: queryArg.createDeliverableMatch,
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      deliverableMatchesRetrieve: build.query<
        DeliverableMatchesRetrieveApiResponse,
        DeliverableMatchesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/`,
        }),
        providesTags: ["deliverable_matches"],
      }),
      deliverableMatchesUpdate: build.mutation<
        DeliverableMatchesUpdateApiResponse,
        DeliverableMatchesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateDeliverableMatch,
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      deliverableMatchesPartialUpdate: build.mutation<
        DeliverableMatchesPartialUpdateApiResponse,
        DeliverableMatchesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateDeliverableMatch,
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      deliverableMatchesDestroy: build.mutation<
        DeliverableMatchesDestroyApiResponse,
        DeliverableMatchesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      deliverableMatchesApprove: build.mutation<
        DeliverableMatchesApproveApiResponse,
        DeliverableMatchesApproveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/approve/`,
          method: "POST",
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      deliverableMatchesReject: build.mutation<
        DeliverableMatchesRejectApiResponse,
        DeliverableMatchesRejectApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.deliverableId}/matches/${queryArg.id}/reject/`,
          method: "POST",
        }),
        invalidatesTags: ["deliverables", "deliverable_matches"],
      }),
      taskDeliverablesRetrieve: build.query<
        TaskDeliverablesRetrieveApiResponse,
        TaskDeliverablesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.id}/`,
        }),
        providesTags: ["deliverables"],
      }),
      taskDeliverablesUpdate: build.mutation<
        TaskDeliverablesUpdateApiResponse,
        TaskDeliverablesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.updateDeliverableStatus,
        }),
        invalidatesTags: ["deliverables"],
      }),
      taskDeliverablesPartialUpdate: build.mutation<
        TaskDeliverablesPartialUpdateApiResponse,
        TaskDeliverablesPartialUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdateDeliverableStatus,
        }),
        invalidatesTags: ["deliverables"],
      }),
      taskDeliverablesDestroy: build.mutation<
        TaskDeliverablesDestroyApiResponse,
        TaskDeliverablesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["deliverables"],
      }),
      taskDeliverablesBypass: build.mutation<
        TaskDeliverablesBypassApiResponse,
        TaskDeliverablesBypassApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/${queryArg.id}/bypass/`,
          method: "POST",
        }),
        invalidatesTags: ["deliverables"],
      }),
      taskDeliverablesSummary: build.query<
        TaskDeliverablesSummaryApiResponse,
        TaskDeliverablesSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/tasks/${queryArg.taskId}/deliverables/summary/`,
        }),
        providesTags: ["deliverables"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type MatterDeliverablesListApiResponse =
  /** status 200  */ DeliverableSchemaRead[];
export type MatterDeliverablesListApiArg = {
  matterId: string;
};
export type MatterDeliverablesRetrieveApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type MatterDeliverablesRetrieveApiArg = {
  id: string;
  matterId: string;
};
export type MatterDeliverablesBatchCreateApiResponse =
  /** status 201  */ DeliverableSchemaRead;
export type MatterDeliverablesBatchCreateApiArg = {
  matterId: string;
  createDeliverable: CreateDeliverable;
};
export type MatterDeliverablesPendingApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type MatterDeliverablesPendingApiArg = {
  matterId: string;
};
export type MatterDeliverablesScanApiResponse = /** status 202  */ {
  [key: string]: any;
};
export type MatterDeliverablesScanApiArg = {
  matterId: string;
};
export type MatterDeliverablesScanStatusApiResponse = /** status 200  */ {
  [key: string]: any;
};
export type MatterDeliverablesScanStatusApiArg = {
  matterId: string;
};
export type MatterDeliverablesSummaryApiResponse = /** status 200  */ {
  [key: string]: any;
};
export type MatterDeliverablesSummaryApiArg = {
  matterId: string;
};
export type TaskDeliverablesListApiResponse =
  /** status 200  */ DeliverableSchemaRead[];
export type TaskDeliverablesListApiArg = {
  matterId: string;
  taskId: string;
};
export type TaskDeliverablesCreateApiResponse =
  /** status 201  */ DeliverableSchemaRead;
export type TaskDeliverablesCreateApiArg = {
  matterId: string;
  taskId: string;
  createDeliverable: CreateDeliverable;
};
export type DeliverableMatchesListApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead[];
export type DeliverableMatchesListApiArg = {
  deliverableId: string;
  matterId: string;
  taskId: string;
};
export type DeliverableMatchesCreateApiResponse =
  /** status 201  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesCreateApiArg = {
  deliverableId: string;
  matterId: string;
  taskId: string;
  createDeliverableMatch: CreateDeliverableMatch;
};
export type DeliverableMatchesRetrieveApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesRetrieveApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
};
export type DeliverableMatchesUpdateApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesUpdateApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
  updateDeliverableMatch: UpdateDeliverableMatch;
};
export type DeliverableMatchesPartialUpdateApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesPartialUpdateApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
  patchedUpdateDeliverableMatch: UpdateDeliverableMatch2;
};
export type DeliverableMatchesDestroyApiResponse = unknown;
export type DeliverableMatchesDestroyApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
};
export type DeliverableMatchesApproveApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesApproveApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
};
export type DeliverableMatchesRejectApiResponse =
  /** status 200  */ DeliverableMatchSchemaRead;
export type DeliverableMatchesRejectApiArg = {
  deliverableId: string;
  id: string;
  matterId: string;
  taskId: string;
};
export type TaskDeliverablesRetrieveApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type TaskDeliverablesRetrieveApiArg = {
  id: string;
  matterId: string;
  taskId: string;
};
export type TaskDeliverablesUpdateApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type TaskDeliverablesUpdateApiArg = {
  id: string;
  matterId: string;
  taskId: string;
  updateDeliverableStatus: UpdateDeliverableStatus;
};
export type TaskDeliverablesPartialUpdateApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type TaskDeliverablesPartialUpdateApiArg = {
  id: string;
  matterId: string;
  taskId: string;
  patchedUpdateDeliverableStatus: UpdateDeliverableStatus2;
};
export type TaskDeliverablesDestroyApiResponse = unknown;
export type TaskDeliverablesDestroyApiArg = {
  id: string;
  matterId: string;
  taskId: string;
};
export type TaskDeliverablesBypassApiResponse =
  /** status 200  */ DeliverableSchemaRead;
export type TaskDeliverablesBypassApiArg = {
  id: string;
  matterId: string;
  taskId: string;
};
export type TaskDeliverablesSummaryApiResponse = /** status 200  */ {
  [key: string]: any;
};
export type TaskDeliverablesSummaryApiArg = {
  matterId: string;
  taskId: string;
};
export type DeliverableArtifactCriteria = {
  search_keywords?: string[] | null;
  exclusion_keywords?: string[] | null;
};
export type DeliverableAnchors = {
  facts?: {
    [key: string]: string;
  };
};
export type DeliverableStatus = "Pending" | "Satisfied" | "Bypassed";
export type TaskGroups =
  | "Intake"
  | "Initial Review"
  | "Police Report & Investigation"
  | "1P Insurance"
  | "3P Insurance"
  | "Medical Records"
  | "Treatment"
  | "Demand Letter"
  | "Liens"
  | "Miscellaneous"
  | "Additional Insurance"
  | "Mini Tort"
  | "Initial Medical Records";
export type TaskType =
  | "Medical Records"
  | "Medical Bills"
  | "LOR Acknowledgement"
  | "Send LOR"
  | "Open Claim"
  | "Final Lien"
  | "Lien Acknowledgement"
  | "Police Report"
  | "Police Report Escalation"
  | "Freedom of Information Act"
  | "Incident Report"
  | "Open File"
  | "Find Health Insurance Coverage"
  | "Locate Report Source"
  | "Ascertain Subrogator"
  | "Finalize Demand"
  | "Draft Demand"
  | "Demand Readiness Review"
  | "Declaration Page"
  | "Health Insurance Card"
  | "Treatment Check-In"
  | "Treatment Barrier"
  | "HIPAA Directive"
  | "Retainer Agreement"
  | "Conduct Intake"
  | "Conduct Initial Review"
  | "Welcome Call"
  | "Other"
  | "All"
  | "Review Found Coverage"
  | "Review Found Provider"
  | "Update External CMS"
  | "Find 1P Coverage"
  | "Find 3P Coverage"
  | "Client Communications"
  | "Managing Paralegal Asks"
  | "Manage MedPay"
  | "Send MedPay Letter"
  | "Get Liability Limits"
  | "Request Updated PIP Ledger"
  | "Send Evidence Preservation Letter"
  | "Document Collection"
  | "Review 1P Benefits"
  | "PIP/MedPay Application"
  | "Check for PIP Ledger"
  | "IME Required"
  | "UM/UIM Indicate Stack vs. No Stack"
  | "Generate No Medpay Letter"
  | "Provide PIP Info to Medical Provider"
  | "Liability Other"
  | "1P Insurance Other"
  | "3P Insurance Other"
  | "Liens Other"
  | "Treatment Other"
  | "Medical Records Other"
  | "Demand Letter Other"
  | "Confirm Incident Location"
  | "Research Property & Owners"
  | "Mini Tort Review"
  | "Mini Tort Review Escalation"
  | "Mini Tort Letter"
  | "Mini Tort Chase";
export type TaskUpdateType = "comment" | "activity";
export type TaskUpdateVisibility = "Private" | "Public";
export type CustomUserSchema = {
  id: string | string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  is_firm_admin?: boolean;
  avatar?: string | null;
  signature?: string | null;
};
export type AgentType =
  | "ingest_transcript_task"
  | "provider_finder"
  | "artifact_digest"
  | "treatment_researcher"
  | "treatment_request_automation"
  | "bland_caller"
  | "voice_ai"
  | "slack_task_bot"
  | "blob_sorter"
  | "front_app_integration"
  | "task_generator"
  | "coverage_extractor"
  | "intake_converter"
  | "airtable_sync"
  | "system"
  | "backfill_script"
  | "domain_event_update_orchestrator"
  | "loa_detector"
  | "rainmaker"
  | "deliverable_sync"
  | "bpo_agent"
  | "upwork"
  | "loa_chaser"
  | "external_task_rule_engine"
  | "external_task_bulk_create"
  | "entity_sync"
  | "case_activation"
  | "matter_wiki_generator"
  | "mini_tort_webhook"
  | "mini_tort_pipeline";
export type TaskUpdateSchema = {
  id: string | string;
  task_id: string | string;
  update: string;
  update_type: TaskUpdateType;
  visibility: TaskUpdateVisibility;
  user?: CustomUserSchema;
  agent?: AgentType;
  agent_tags?: string[];
  correlation_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
};
export type TaskExternalCmsUpdateStatus = "NOT_UPDATED" | "UPDATED";
export type TaskWithUpdatesSchema = {
  id: string | string;
  name?: string | null;
  description?: string | null;
  group: TaskGroups;
  type: TaskType;
  due_date?: string | null;
  updates: TaskUpdateSchema[];
  external_cms_update_status?: TaskExternalCmsUpdateStatus;
  external_cms_update_reason?: string | null;
};
export type FirmStatus =
  | "Active"
  | "Testing"
  | "Software Only"
  | "New Lead"
  | "Open"
  | "Closed";
export type FirmType = "Solo" | "Small" | "Medium" | "Enterprise";
export type TimeZone = "PST" | "MST" | "CST" | "EST" | "AKST" | "AST" | "HST";
export type CmsSystem =
  | "CASEpeer"
  | "Filevine"
  | "Litify"
  | "MyCase"
  | "Clio Manage"
  | "SmartAdvocate"
  | "PracticePanther"
  | "Needles"
  | "Neos"
  | "Merus"
  | "TrialWorks"
  | "Lawmatics";
export type LeadSystem =
  | "LeadDocket"
  | "LawProNation"
  | "ClioGrow"
  | "Intaker"
  | "Lawmatics"
  | "CASEpeer"
  | "Filevine"
  | "Litify"
  | "MyCase"
  | "Clio Manage"
  | "SmartAdvocate"
  | "PracticePanther"
  | "Needles"
  | "Neos"
  | "Merus"
  | "TrialWorks";
export type IntakePreferenceSection = {
  title: string;
  content: string;
};
export type QualificationAction = "accept" | "reject" | "escalate";
export type QualificationCriteria = {
  /** Maximum days from today for date of loss. None means no restriction. */
  date_of_loss_max_days?: number | null;
  /** List of 2-letter US state codes. Empty means all states accepted. */
  accepted_states?: string[];
  /** Per case type actions. Missing types use default action. */
  case_type_actions?: {
    [key: string]: QualificationAction;
  };
  /** Default action for unconfigured case types. */
  default_case_type_action?: QualificationAction;
};
export type IntakePreferences = {
  sections?: IntakePreferenceSection[];
  /** Qualification criteria for intake decision support. */
  qualification_criteria?: QualificationCriteria;
};
export type FirmSchema = {
  id: string;
  name: string;
  full_name?: string | null;
  email?: string | null;
  adobe_sign_email?: string | null;
  status?: FirmStatus;
  type?: FirmType;
  is_paying?: boolean;
  is_mini_tort?: boolean;
  paying_since?: string | null;
  time_zone?: TimeZone;
  primary_state?: string | null;
  managing_paralegal_id?: (string | string) | null;
  cms_system?: CmsSystem;
  cms_link?: string | null;
  lead_system?: LeadSystem;
  lead_system_link?: string | null;
  intake_preferences: IntakePreferences;
  case_preferences?: string | null;
  commentary?: string | null;
  errors?: string | null;
  plan_to_derisk?: string | null;
  pre_filing_contingency_fee?: string | null;
  post_filing_contingency_fee?: string | null;
  sms_sender_number?: string | null;
  sms_sender_name?: string | null;
  fax?: string | null;
  letterhead_url?: string | null;
  firm_footer_url?: string | null;
  firm_logo_url?: string | null;
  firm_watermark_url?: string | null;
  cleaned_firm_logo_url?: string | null;
  cleaned_firm_footer_url?: string | null;
  cleaned_firm_watermark_url?: string | null;
  cleaned_letterhead_url?: string | null;
  auto_backfill_external_task_rules_on_import?: boolean;
};
export type MatterType =
  | "Motor Vehicle Accident"
  | "Medical Malpractice"
  | "Miscellaneous"
  | "Breach of Employment Contract"
  | "Seller Non-Disclosure"
  | "Premises Liability"
  | "Broker Negligence"
  | "Property Damage"
  | "Dog Bite"
  | "Wrongful Death"
  | "Unknown";
export type MatterStatus =
  | "New Lead"
  | "Intake"
  | "Case Ingestion"
  | "Initial Review"
  | "Case Setup"
  | "Treatment"
  | "Treatment Complete"
  | "Ready for Demand"
  | "Demand Preparation"
  | "Demand Letter"
  | "Litigation"
  | "Complete"
  | "Hidden"
  | "In Progress"
  | "Client Dropped"
  | "To Be Dropped";
export type MatterSchemaForDeliverable = {
  id: string | string;
  name?: string | null;
  matter_type?: MatterType;
  status?: MatterStatus;
  date_of_loss?: string | null;
  statute_of_limitations_date?: string | null;
  city?: string | null;
  state?: string | null;
  created_at?: string | null;
  modified_at?: string | null;
  representing_attorney_id?: (string | string) | null;
  external_cms_url?: string | null;
  cms_email?: string | null;
  referral_source_description?: string | null;
};
export type AddressUpdateModel = {
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  country?:
    | (
        | "AF"
        | "AX"
        | "AL"
        | "DZ"
        | "AS"
        | "AD"
        | "AO"
        | "AI"
        | "AQ"
        | "AG"
        | "AR"
        | "AM"
        | "AW"
        | "AU"
        | "AT"
        | "AZ"
        | "BS"
        | "BH"
        | "BD"
        | "BB"
        | "BY"
        | "BE"
        | "BZ"
        | "BJ"
        | "BM"
        | "BT"
        | "BO"
        | "BQ"
        | "BA"
        | "BW"
        | "BV"
        | "BR"
        | "IO"
        | "BN"
        | "BG"
        | "BF"
        | "BI"
        | "CV"
        | "KH"
        | "CM"
        | "CA"
        | "KY"
        | "CF"
        | "TD"
        | "CL"
        | "CN"
        | "CX"
        | "CC"
        | "CO"
        | "KM"
        | "CG"
        | "CD"
        | "CK"
        | "CR"
        | "CI"
        | "HR"
        | "CU"
        | "CW"
        | "CY"
        | "CZ"
        | "DK"
        | "DJ"
        | "DM"
        | "DO"
        | "EC"
        | "EG"
        | "SV"
        | "GQ"
        | "ER"
        | "EE"
        | "SZ"
        | "ET"
        | "FK"
        | "FO"
        | "FJ"
        | "FI"
        | "FR"
        | "GF"
        | "PF"
        | "TF"
        | "GA"
        | "GM"
        | "GE"
        | "DE"
        | "GH"
        | "GI"
        | "GR"
        | "GL"
        | "GD"
        | "GP"
        | "GU"
        | "GT"
        | "GG"
        | "GN"
        | "GW"
        | "GY"
        | "HT"
        | "HM"
        | "VA"
        | "HN"
        | "HK"
        | "HU"
        | "IS"
        | "IN"
        | "ID"
        | "IR"
        | "IQ"
        | "IE"
        | "IM"
        | "IL"
        | "IT"
        | "JM"
        | "JP"
        | "JE"
        | "JO"
        | "KZ"
        | "KE"
        | "KI"
        | "KP"
        | "KR"
        | "KW"
        | "KG"
        | "LA"
        | "LV"
        | "LB"
        | "LS"
        | "LR"
        | "LY"
        | "LI"
        | "LT"
        | "LU"
        | "MO"
        | "MG"
        | "MW"
        | "MY"
        | "MV"
        | "ML"
        | "MT"
        | "MH"
        | "MQ"
        | "MR"
        | "MU"
        | "YT"
        | "MX"
        | "FM"
        | "MD"
        | "MC"
        | "MN"
        | "ME"
        | "MS"
        | "MA"
        | "MZ"
        | "MM"
        | "NA"
        | "NR"
        | "NP"
        | "NL"
        | "NC"
        | "NZ"
        | "NI"
        | "NE"
        | "NG"
        | "NU"
        | "NF"
        | "MK"
        | "MP"
        | "NO"
        | "OM"
        | "PK"
        | "PW"
        | "PS"
        | "PA"
        | "PG"
        | "PY"
        | "PE"
        | "PH"
        | "PN"
        | "PL"
        | "PT"
        | "PR"
        | "QA"
        | "RE"
        | "RO"
        | "RU"
        | "RW"
        | "BL"
        | "SH"
        | "KN"
        | "LC"
        | "MF"
        | "PM"
        | "VC"
        | "WS"
        | "SM"
        | "ST"
        | "SA"
        | "SN"
        | "RS"
        | "SC"
        | "SL"
        | "SG"
        | "SX"
        | "SK"
        | "SI"
        | "SB"
        | "SO"
        | "ZA"
        | "GS"
        | "SS"
        | "ES"
        | "LK"
        | "SD"
        | "SR"
        | "SJ"
        | "SE"
        | "CH"
        | "SY"
        | "TW"
        | "TJ"
        | "TZ"
        | "TH"
        | "TL"
        | "TG"
        | "TK"
        | "TO"
        | "TT"
        | "TN"
        | "TR"
        | "TM"
        | "TC"
        | "TV"
        | "UG"
        | "UA"
        | "AE"
        | "GB"
        | "US"
        | "UM"
        | "UY"
        | "UZ"
        | "VU"
        | "VE"
        | "VN"
        | "VG"
        | "VI"
        | "WF"
        | "EH"
        | "YE"
        | "ZM"
        | "ZW"
      )
    | null;
};
export type MatterClientPhoneNumberSchema = {
  phone_number: string;
};
export type MatterClientSchema = {
  id?: (string | string) | null;
  name?: string | null;
  email?: string | null;
  date_of_birth?: string | null;
  last_four_of_ssn?: string | null;
  preferred_language?: string | null;
  address?: AddressUpdateModel;
  phone_numbers?: MatterClientPhoneNumberSchema[];
};
export type PolicyType =
  | "AUTO"
  | "HOMEOWNERS"
  | "COMMERCIAL"
  | "HEALTH"
  | "UMBRELLA"
  | "WORKERS_COMPENSATION"
  | "GENERAL_LIABILITY"
  | "OTHER";
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type CarrierDetail = {
  /**
            The colloquial, common form, well-known name of the insurance carrier if mentioned, null otherwise.
            This is a key field for matching and deduplication.
             */
  name?: string | null;
  /**
            The BEST (at _MOST_ 2 handles per type) web pages or phone numbers for submitting and managing claims if mentioned, null otherwise.
             */
  handles?: ContactHandleSchema[] | null;
  /**
            The headquarters address of the insurance carrier if mentioned, null otherwise.
             */
  address?: string | null;
};
export type IdentifierType =
  | "POLICY_NUMBER"
  | "MEMBER_ID"
  | "GROUP_NUMBER"
  | "OTHER";
export type CoverageDataSource =
  | "UNKNOWN"
  | "BPO"
  | "USER_EDIT"
  | "SYSTEM"
  | "VOICE_AI";
export type CoverageDataSourceInfo = {
  /** The source that created or last modified this data. */
  source?: CoverageDataSource;
  /** User ID if source is USER_EDIT. */
  user_id?: string | null;
  /** User display name if source is USER_EDIT (for display purposes). */
  user_name?: string | null;
  /** When the data was added/modified from this source. */
  timestamp?: string | null;
};
export type PolicyIdentifier = {
  /**
            The type of identifier for the policy.
             */
  identifier_type: IdentifierType;
  /**
            The value of the identifier for the policy.
             */
  identifier_value: string;
  /**
            Metadata about the source of this policy identifier data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type BenefitType =
  | "PERSONAL_INJURY_PROTECTION"
  | "MEDICAL_PAYMENTS"
  | "UNINSURED_MOTORIST"
  | "UNDER_INSURED_MOTORIST"
  | "BODILY_INJURY_LIABILITY"
  | "PROPERTY_DAMAGE_LIABILITY"
  | "COMPREHENSIVE_AUTO"
  | "COLLISION_AUTO"
  | "WORKERS_COMPENSATION"
  | "OTHER";
export type BenefitDetail = {
  /**
            A limited categorization of insurance benefits we are interested in extracting.
            
            <benefits-type-glossary>
                PIP == PERSONAL_INJURY_PROTECTION
                MEDPAY == MEDICAL_PAYMENTS
                UM == UNINSURED_MOTORIST
                UIM == UNDER_INSURED_MOTORIST
                BI == BODILY_INJURY_LIABILITY
                COMPREHENSIVE == COMPREHENSIVE_AUTO
                COLLISION == COLLISION_AUTO
                anything else == OTHER
            </benefits-type-glossary>
              
             */
  benefit_type?: BenefitType;
  /**
            Structured map of coverage limitation labels to their numeric dollar amounts.
            Keys describe the limit type (e.g., "per person", "per accident", "bodily injury per person").
            Values MUST be integers representing dollar amounts (e.g., 25000 for $25,000).
    
            IMPORTANT: Do NOT use slash notation like "25000/50000". Instead, create SEPARATE entries:
            - WRONG: {"bodily injury": "25000/50000"}
            - CORRECT: {"bodily injury per person": 25000, "bodily injury per accident": 50000}
    
            Examples:
            - {"per person": 100000, "per accident": 300000}
            - {"BI per person": 25000, "BI per accident": 50000, "PD": 25000}
            - {"medical payments": 5000}
             */
  limitations?: {
    [key: string]: number;
  } | null;
  /**
            Whether stacking benefits apply for UM/UIM coverage. When true, coverage limits from
            multiple policies can be combined. Only applicable for UNINSURED_MOTORIST and
            UNDER_INSURED_MOTORIST benefit types. Null indicates unknown/not specified.
             */
  is_stacked?: boolean | null;
  /**
            Metadata about the source of this benefit data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type AdjusterDetail = {
  /**
            The benefit the adjuster is specifically assigned to, if explicitly stated, otherwise null.
             */
  benefit_type?: BenefitType;
  /**
            Name of the adjuster handling a related claim if explicitly stated, otherwise null.
             */
  name?: string | null;
  /**
            The BEST (at MOST 2 handles per type) contact methods for the adjuster (phone, email, fax) if explicitly stated,
            otherwise null.
             */
  handles?: ContactHandleSchema[] | null;
  /**
            Metadata about the source of this adjuster data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type ClaimDetail = {
  /**
            The benefit against which the claim is being made, if explicitly stated, otherwise null.
            
            <benefits-type-glossary>
                PIP == PERSONAL_INJURY_PROTECTION
                MEDPAY == MEDICAL_PAYMENTS
                UM == UNINSURED_MOTORIST
                UIM == UNDER_INSURED_MOTORIST
                BI == BODILY_INJURY_LIABILITY
                COMPREHENSIVE == COMPREHENSIVE_AUTO
                COLLISION == COLLISION_AUTO
                anything else == OTHER
            </benefits-type-glossary>
              
             */
  benefit_type?: BenefitType;
  /**
            The claim identifier (number, id, etc.) for the policy, if explicitly stated, otherwise null.
             */
  claim_identifier?: string | null;
  /**
            Metadata about the source of this claim data (BPO, user edit, system, etc.).
            None indicates unknown/legacy data for backwards compatibility.
             */
  source?: CoverageDataSourceInfo;
};
export type VehicleDetail = {
  /**
            The ID of the Vehicle record from the Vehicle table, if this detail
            was created from a known Vehicle record. Used for unambiguous matching
            when multiple vehicles share the same year/make/model.
             */
  vehicle_id?: string | null;
  /**
            The make of the vehicle if explicitly stated, otherwise null.
             */
  make?: string | null;
  /**
            The model of the vehicle if explicitly stated, otherwise null.
             */
  model?: string | null;
  /**
            The year of the vehicle if explicitly stated, otherwise null.
             */
  year?: number | null;
  /**
            The VIN of the vehicle if explicitly stated, otherwise null.
             */
  vin?: string | null;
  /**
            The license plate of the vehicle if explicitly stated, otherwise null.
             */
  license_plate?: string | null;
  /**
            The color of the vehicle if explicitly stated, otherwise null.
             */
  color?: string | null;
};
export type PolicyDetail = {
  /**
            A well formatted label for the policy detail, i.e "VIN", "Vehicle Description", "Premium", "Insured Address", "Garage Address"
             */
  key: string;
  /**
            The value of the policy detail, i.e "1234567890", "Toyota Camry", "100000.00"
             */
  value: string;
};
export type SubrogatorDetail = {
  /**
            Name of the subrogator handling a related claim if explicitly stated, otherwise null.
             */
  name?: string | null;
  /**
            The BEST (at MOST 2 handles per type) contact methods for the subrogator (phone, email, fax) if explicitly stated,
            otherwise null.
             */
  handles?: ContactHandleSchema[] | null;
  /**
            List of sources that provided the subrogator information if explicitly stated, otherwise null.
             */
  sources?: WebSource[] | null;
};
export type PropertyContactType =
  | "PROPERTY_OWNER"
  | "PROPERTY_MANAGER"
  | "OTHER";
export type PropertyContact = {
  /** The type of contact (owner, manager, or other). */
  contact_type: PropertyContactType;
  /** Custom label when contact_type is OTHER (e.g., 'Tenant', 'Security Company'). */
  custom_type_label?: string | null;
  /** Name of the contact person or entity. */
  name?: string | null;
  /** Contact methods: phone, email, fax, etc. */
  handles?: ContactHandleSchema[] | null;
  /** Mailing address for the contact. */
  address?: string | null;
  /** Additional notes about this contact. */
  notes?: string | null;
};
export type CoverageStatus =
  | "NEEDS_APPROVAL"
  | "APPROVED"
  | "REJECTED"
  | "NOT_APPLICABLE"
  | "DUPLICATE";
export type ClientDecision = "APPROVED" | "DECLINED";
export type CoverageLiabilityStatus =
  | "ACCEPTED"
  | "REJECTED"
  | "PARTIALLY_ACCEPTED"
  | "LIABILITY_UNKNOWN"
  | "UNDER_INVESTIGATION";
export type CoverageCategory =
  | "FIRST_PARTY"
  | "FIRST_PARTY_HEALTH"
  | "THIRD_PARTY"
  | "NOT_LIABLE_INVOLVED_PARTY"
  | "UNCLEAR"
  | "PROPERTY"
  | "WORKERS_COMPENSATION";
export type ArtifactType =
  | "TRANSCRIPT"
  | "AUDIO_CONVERSATION"
  | "DOCUMENT"
  | "EMAIL"
  | "EMAIL_ATTACHMENT"
  | "INTAKE_NOTE"
  | "MESSAGE"
  | "MESSAGE_ATTACHMENT"
  | "CONVERSATION"
  | "BLOB"
  | "STAFF_NOTE";
export type CoverageMentionStubSchema = {
  id: string | string;
  created_at: string;
  artifact_id: string | string;
  artifact_type: ArtifactType;
  citation_ids?: string[] | null;
  confidence?: number | null;
  context?: string | null;
};
export type EnrichmentSource =
  | "perplexity"
  | "cached"
  | "manual"
  | "intake"
  | "extraction";
export type EnrichmentMetadata = {
  source_matter_id?: string | null;
  source_matter_name?: string | null;
  match_reason?: string | null;
  cached_at?: string | null;
  confidence_score?: number | null;
  [key: string]: any;
};
export type LorUploadedArtifactSummary = {
  id: string | string;
  blob_id?: (string | string) | null;
  name?: string | null;
  original_filename?: string | null;
  file_extension?: string | null;
  file_mime_type?: string | null;
  created_at?: string | null;
};
export type OpenClaimFieldStatus =
  | "VERIFIED"
  | "SUGGESTED"
  | "MISSING"
  | "UNKNOWN"
  | "WRONG";
export type OpenClaimCitedFieldStr = {
  /** The discovered or existing value for this field. */
  value?: string | null;
  /** The verification status of this field. */
  status?: OpenClaimFieldStatus;
  /** Confidence score (0-1) for the accuracy of this value. */
  confidence?: number | null;
  /** Citation IDs linking to source text in documents. */
  citation_ids?: string[];
  /** Artifact ID of the primary source document. */
  source_artifact_id?: (string | string) | null;
  /** Brief explanation of why this value was suggested or verified. */
  reasoning?: string | null;
};
export type OpenClaimClientInfo = {
  /** Client's full legal name. */
  name?: OpenClaimCitedFieldStr;
  /** Client's contact phone number. */
  phone?: OpenClaimCitedFieldStr;
  /** Client's email address. */
  email?: OpenClaimCitedFieldStr;
  /** Client's current mailing address (street address). */
  address?: OpenClaimCitedFieldStr;
  /** Client's city. */
  city?: OpenClaimCitedFieldStr;
  /** Client's state/province. */
  state?: OpenClaimCitedFieldStr;
  /** Client's ZIP code. */
  zip_code?: OpenClaimCitedFieldStr;
  /** Client's date of birth (MM/DD/YYYY). */
  dob?: OpenClaimCitedFieldStr;
  /** Last four digits of client's Social Security Number. */
  last_four_ssn?: OpenClaimCitedFieldStr;
};
export type OpenClaimIncidentInfo = {
  /** Date the incident occurred (MM/DD/YYYY). */
  date_of_loss?: OpenClaimCitedFieldStr;
  /** Time the incident occurred (e.g., 2:30 PM or 14:30). */
  time_of_loss?: OpenClaimCitedFieldStr;
  /** Location where the incident occurred (street address or intersection). */
  location?: OpenClaimCitedFieldStr;
  /** Weather conditions at time of incident. */
  weather_conditions?: OpenClaimCitedFieldStr;
  /** Brief description of how the incident occurred. */
  incident_description?: OpenClaimCitedFieldStr;
};
export type OpenClaimCitedFieldUnionIntNoneType = {
  /** The discovered or existing value for this field. */
  value?: number | null;
  /** The verification status of this field. */
  status?: OpenClaimFieldStatus;
  /** Confidence score (0-1) for the accuracy of this value. */
  confidence?: number | null;
  /** Citation IDs linking to source text in documents. */
  citation_ids?: string[];
  /** Artifact ID of the primary source document. */
  source_artifact_id?: (string | string) | null;
  /** Brief explanation of why this value was suggested or verified. */
  reasoning?: string | null;
};
export type OpenClaimVehicleInfo = {
  /** Vehicle model year. */
  year?: OpenClaimCitedFieldUnionIntNoneType;
  /** Vehicle manufacturer (e.g., Toyota, Ford). */
  make?: OpenClaimCitedFieldStr;
  /** Vehicle model name (e.g., Camry, F-150). */
  model?: OpenClaimCitedFieldStr;
  /** Vehicle Identification Number. */
  vin?: OpenClaimCitedFieldStr;
  /** License plate number and state. */
  license_plate?: OpenClaimCitedFieldStr;
  /** Vehicle color. */
  color?: OpenClaimCitedFieldStr;
  /** UUID of the coverage this vehicle should be assigned to. */
  suggested_coverage_id?: OpenClaimCitedFieldStr;
};
export type OpenClaimCoverageInfo = {
  /** Name of the insurance carrier. */
  carrier_name?: OpenClaimCitedFieldStr;
  /** Policy number on the insurance card/documents. */
  policy_number?: OpenClaimCitedFieldStr;
  /** Claims phone number for the carrier. */
  carrier_phone?: OpenClaimCitedFieldStr;
  /** Name of the policyholder/named insured. */
  named_insured?: OpenClaimCitedFieldStr;
  /** Existing claim number if a claim has already been filed. */
  claim_number?: OpenClaimCitedFieldStr;
};
export type OpenClaimAtFaultDriverInfo = {
  /** Name of the at-fault or other involved driver. */
  name?: OpenClaimCitedFieldStr;
  /** Phone number of the at-fault driver. */
  phone?: OpenClaimCitedFieldStr;
  /** Address of the at-fault driver. */
  address?: OpenClaimCitedFieldStr;
};
export type OpenClaimContextSchema = {
  /** Client/claimant information. */
  client?: OpenClaimClientInfo;
  /** Details about the incident/accident. */
  incident?: OpenClaimIncidentInfo;
  /** Client's vehicle(s) involved in the incident. */
  client_vehicles?: OpenClaimVehicleInfo[];
  /** Insurance coverage details. */
  coverage?: OpenClaimCoverageInfo;
  /** At-fault or other party driver information. */
  at_fault_driver?: OpenClaimAtFaultDriverInfo;
  /** At-fault or other party vehicle information. */
  defendant_vehicle?: OpenClaimVehicleInfo;
  /** At-fault or other party vehicles (supports multiple). Use this for multi-vehicle incidents; legacy defendant_vehicle is still accepted. */
  defendant_vehicles?: OpenClaimVehicleInfo[];
  /** City where the incident/matter is located. */
  matter_city?: OpenClaimCitedFieldStr;
  /** State where the incident/matter is located. */
  matter_state?: OpenClaimCitedFieldStr;
  /** ISO timestamp when AI discovery completed. */
  discovery_completed_at?: string | null;
  /** Summary of what was found and what's missing. */
  discovery_summary?: string | null;
};
export type CoverageSchema = {
  /**
            The type of policy if explicitly stated, otherwise null.
             */
  policy_type?: PolicyType;
  /**
            Details about the insurance carrier if mentioned, otherwise null.
             */
  carrier?: CarrierDetail;
  /**
            Carrier-issued identifiers for the policy, if explicitly stated, otherwise null.
             */
  policy_identifiers?: PolicyIdentifier[] | null;
  /**
            List of names of primary policyholders or insured entities if stated or implied, otherwise null.
             */
  named_insured?: string[] | null;
  /**
            List of benefits covered by the policy, if explicitly stated, otherwise null.
             */
  benefits?: BenefitDetail[] | null;
  /**
            Any known adjusters handling claims against this policy, if explicitly stated, otherwise null.
             */
  adjusters?: AdjusterDetail[] | null;
  /**
            Any known claims opened against the policy, if explicitly stated, otherwise null.
             */
  claims?: ClaimDetail[] | null;
  /**
            List of vehicles covered by the policy, if applicable and explicitly stated, otherwise null.
             */
  vehicles?: VehicleDetail[] | null;
  /**
            Structured list of extracted policy details, such as, but not limited to:
            VIN; vehicle description; premium amount; insured's address;
            garage location; policy endorsements; coverage exclusions;
            other policy-specific information for claims processing.
             */
  policy_details?: PolicyDetail[] | null;
  /**
            Details about the subrogator if health insurance policy + carrier ... if explicitly stated, otherwise null.
             */
  subrogator?: SubrogatorDetail;
  /**
            DEPRECATED: Use Property.owners instead. Owner/manager information is now stored via
            Organization parties linked to the Property subject through Ownership records.
            This field is retained for backward compatibility with existing data but is no longer
            populated for new coverages.
             */
  property_contacts?: PropertyContact[] | null;
  id: string | string;
  status?: CoverageStatus;
  client_decision?: ClientDecision;
  liability_status?: CoverageLiabilityStatus;
  category?: CoverageCategory;
  matter_id: string | string;
  created_at: string;
  modified_at: string;
  /**
            List of mentions of this coverage in the matter, if any.
             */
  mentions?: CoverageMentionStubSchema[] | null;
  carrier_v2_id?: (string | string) | null;
  carrier_division_id?: (string | string) | null;
  /** Source of enrichment data for carrier information */
  enrichment_source?: EnrichmentSource;
  /** Metadata about enrichment source (source matter ID, match reason, etc.) */
  enrichment_metadata?: EnrichmentMetadata;
  /** Whether cached data was used for enrichment */
  cache_used?: boolean;
  lor_document_id?: (string | string) | null;
  lor_uploaded_artifact_id?: (string | string) | null;
  lor_uploaded_artifact?: LorUploadedArtifactSummary;
  /** AI-discovered context for opening a claim with citations and confidence scores. */
  open_claim_context?: OpenClaimContextSchema;
  created_by_user_id?: (string | string) | null;
  created_by_user_name?: string | null;
  /** For PROPERTY category: UUID of the linked Property subject. */
  property_id?: (string | string) | null;
  /** Whether this is the primary coverage within its party (1P or 3P). */
  is_primary?: boolean;
};
export type ProviderStatus = "NEEDS_APPROVAL" | "APPROVED" | "REJECTED";
export type ProviderTreatmentStatus =
  | "TREATING"
  | "COMPLETED"
  | "DEVIATING"
  | "UNKNOWN"
  | "REFERRED_TO";
export type ProviderType = "ORGANIZATION" | "PRACTITIONER";
export type ProviderSearchResult = {
  /** Name of the practitioner (e.g. 'Dr. John Smith') if explicitly stated, null otherwise. */
  practitioner_name?: string | null;
  /** Common, recognizable name of the healthcare organization (e.g., 'UC San Diego Health', 'Main Street Clinic'). EXCLUDE administrative department names (e.g., 'Medical Records', 'Billing'); these belong in handles. Align with original mention's generality unless search strongly indicates a specific, distinct facility. */
  organization_name?: string | null;
  /** The address of the provider. */
  address?: string | null;
  /** The BEST (at MOST 2 handles per type) contact methods for records/billing retrieval. Do not include scheduling phone numbers, or other patient care oriented phone numbers. */
  handles: ContactHandleSchema[];
  /** A very brief (1-2 sentences) note for paralegal context. */
  internal_note?: string | null;
};
export type EncounterSchema = {
  /** The unique identifier for the encounter */
  id: string;
  /** The date of service for the encounter in ISO format (YYYY-MM-DD), if explicitly stated, null otherwise */
  date?: string | null;
  /** list of short phrases describing care provided in the encounter as mentioned in the artifact, like 'physical therapy', 'labs', 'imaging', etc. if explicitly stated, null otherwise */
  services?: string[];
  /** A very concise description of the encounter, as a one liner that might be used in a medical chronology for the case. Don't repeat the date of service in the description . Explicitly mention any ambiguities about the discovery that merit further investigation (i.e date of service not yet known, etc.) */
  description: string;
};
export type ProviderIdentityLifecycleStatus =
  | "PENDING"
  | "RESOLVED"
  | "DEFERRED"
  | "OVERDUE";
export type TreatmentFrequency =
  | "DAILY"
  | "WEEKLY"
  | "BI_WEEKLY"
  | "MONTHLY"
  | "AS_NEEDED"
  | "OTHER";
export type TreatmentProgress = "IMPROVING" | "STAGNANT" | "REGRESSING";
export type TreatmentCareLevel =
  | "EMERGENCY_CARE"
  | "CONSERVATIVE_CARE"
  | "DIAGNOSTIC_TESTING"
  | "SPECIALIST_CARE"
  | "SURGICAL_CARE";
export type InferredFieldSource = "AI" | "MANUAL";
export type ProcedureType =
  | "ER_VISIT"
  | "URGENT_CARE"
  | "CHIROPRACTIC_VISIT"
  | "PT_VISIT"
  | "MRI"
  | "CT_SCAN"
  | "XRAY"
  | "EMG_NCV"
  | "PAIN_MANAGEMENT_CONSULT"
  | "EPIDURAL_INJECTION"
  | "NERVE_BLOCK"
  | "SURGERY_RECOMMENDED"
  | "SURGERY_PERFORMED"
  | "ORTHO_CONSULT"
  | "FACET_INJECTION"
  | "TRIGGER_POINT_INJECTION"
  | "NEURO_CONSULT"
  | "NEUROPSYCH_EVAL"
  | "OTHER"
  | "UNKNOWN";
export type MedicalProviderSchema = {
  id: string;
  matter_id: string;
  provider_contact_ref_id?: string | null;
  provider_service_ref_id?: string | null;
  name: string;
  status?: ProviderStatus;
  dates_of_service?: string | null;
  treatment?: string | null;
  address?: string | null;
  phone?: string | null;
  fax?: string | null;
  email?: string | null;
  still_treating?: string | null;
  treatment_status?: ProviderTreatmentStatus;
  treatment_status_occurred_at?: string | null;
  date_of_records_request?: string | null;
  provider_type?: ProviderType;
  practitioner_names?: string[] | null;
  description?: string | null;
  handles: ContactHandleSchema[];
  inference_reasoning?: string | null;
  fallback_leads?: ProviderSearchResult[] | null;
  encounters?: EncounterSchema[] | null;
  pain_level?: number | null;
  treatment_notes?: string | null;
  identity_status?: ProviderIdentityLifecycleStatus;
  identity_due_at?: string | null;
  identity_resolved_at?: string | null;
  identity_defer_reason?: string | null;
  treatment_frequency?: TreatmentFrequency;
  treatment_progress?: TreatmentProgress;
  care_level?: TreatmentCareLevel;
  /** Confidence (0-1) for care_level when set by AI. */
  care_level_confidence?: number | null;
  /** Whether care_level was set by AI or manually by a user. */
  care_level_source?: InferredFieldSource;
  /** When care_level was last set/updated. */
  care_level_updated_at?: string | null;
  /** Procedure types inferred for this provider. */
  procedure_types?: ProcedureType[] | null;
  /** Confidence (0-1) for procedure_types when set by AI. */
  procedure_types_confidence?: number | null;
  /** Whether procedure_types was set by AI or manually by a user. */
  procedure_types_source?: InferredFieldSource;
  /** When procedure_types was last set/updated. */
  procedure_types_updated_at?: string | null;
};
export type PoliceReportAttestationStatus =
  | "rejected_verified"
  | "unclear"
  | "inferred"
  | "attested_unverified"
  | "attested_verified"
  | "verified_received";
export type PoliceReportAvailabilityStatus =
  | "verified_ready"
  | "verified_pending"
  | "unknown"
  | "available"
  | "not_available";
export type OfficerDetail = {
  name: string;
  badge_number?: string | null;
  context?: string | null;
};
export type PoliceReportEscalationReason =
  | "cant_verify_attested_report"
  | "verified_ready_but_no_automation_available"
  | "verified_but_unclear_if_ready"
  | "found_on_portal_but_failed_to_retrieve";
export type JurisdictionType =
  | "city"
  | "county"
  | "state"
  | "federal"
  | "tribal"
  | "special";
export type PoliceDepartmentEnrichmentStatus =
  | "not_enriched"
  | "enrichment_in_progress"
  | "enrichment_failed"
  | "enrichment_succeeded";
export type ServiceType =
  | "crash_reports"
  | "foia_equivalent"
  | "criminal_records"
  | "incident_reports"
  | "general_records";
export type PoliceRecordsInquiryMajorVendor =
  | "carfax_crashdocs"
  | "lexis_nexis_buycrash"
  | "independent_portal"
  | "next_request"
  | "gov_qa"
  | "not_a_portal"
  | "txdot_cris";
export type AddressSchema = {
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  province_or_state?: string | null;
  postal_or_zip?: string | null;
  country_code?: string | null;
};
export type MailRequirement =
  | "CLIENT_PHOTO_ID_COPY"
  | "FIRM_LETTERHEAD"
  | "PROOF_OF_REPRESENTATION"
  | "COMPLETED_REQUEST_FORM"
  | "NOTARIZED_REQUEST_FORM";
export type FeeComponent = {
  /** The amount of the fee in cents. */
  amount_cents: number;
  /** One line description of the component of the total fee backed by research and assumptions.
    ex:
    - "Upper bound estimate of 20 pages at $0.25/page as specified by ____"
    - "Estimating up to 30min of labor at stated rate of $20/hour as specified by ____"
    - "Base certified crash report fee $8.44 as specified by ____"
    - "Added 7% for tax because site mentions it's not included in provided info" */
  description: string;
};
export type RecordsFeeEstimate = {
  /** An estimated fee for requesting a copy of a police report.
    Depending on the department, sometimes this is called a "crash report", "accident report",
    "incident report", or "police report".
    
    Rule: IF more than one report option is available, bias to the more expensive, or certified option.
    If fees are not defined for the department, fall back to county or state guidance on fees. */
  estimated_fee_cents?: number | null;
  /** All the components that led to the estimated fee */
  components?: FeeComponent[] | null;
  /** Full verbatim fee details including:
    - Exact language from official source
    - Conditions, alternatives, or special cases
    - Statutory citations (e.g., "per RSMo §610.026")
    - Payment instructions
    ALWAYS populate this when ANY fee information is available. */
  notes?: string | null;
  /** A 0-1 score indicating the confidence. */
  confidence_score?: number | null;
  /** 2-3 sentences explaining the confidence score. */
  reasoning?: string | null;
};
export type CheckMailingInstructions = {
  /** Verifiable instructions on how to request a police report from the agency by mail. */
  instructions?: string;
  /** The mailing address to send the request to. */
  address: AddressSchema;
  /** The best, single name of the entity to make the check payable to. (Payee)
    Do not place anything except for a single, bank-ready name here. */
  payable_to?: string | null;
  /** Any specific text required to be written on the check memo line, if explicitly mentioned, otherwise null.
    Example: "Police Report Request" or "Report #[REPORT_NUMBER]" or "Accident Report Fee"
    available variables: "[REPORT_NUMBER], [CLIENT_NAME], [DATE_OF_LOSS]" */
  memo_instructions?: string | null;
  /** The number of days after incident date to wait before requesting
    the records by mail, if explicitly specified, otherwise null. */
  wait_before_requesting_days?: number | null;
  /** Any department-specified, or state-specified, number of days to expect for processing, if explicitly stated, otherwise null. */
  estimated_processing_days?: number | null;
  /** Any items that are explicitly REQUIRED for requesting a police report by mail, if described, otherwise null. */
  required_items?: MailRequirement[] | null;
  /** Any special requirements for requesting a police report by mail, if described, otherwise null. */
  special_requirements?: string | null;
  /** The estimated set of fees to request a copy of a police report by mail.
    
    - (for any question of the report type being sought): assume we want the most detailed version of the report, sometimes this is "crash report", "accident report", "incident report", "police report", bias to the more expensive of the four
    - (for any page-based fee structure) assume a 20 page incident report
    - (for any requestor-based fee differences) assume legal representative of involved party
    - (for request-method based pricing) assume check + mail but bias to more expensive option
    - (for any charge for a missing report number) assume we do not have the report number
    - (for any charges related to labor) assume 30 minutes of labor
    - (for any charges related to certified copies) assume we are paying for the most certified copy */
  fee_structure?: RecordsFeeEstimate;
  /** Web pages that were used to gather the information. */
  citations?: WebSource[] | null;
};
export type DepartmentForm = {
  /** Concise title for the Form */
  title: string;
  /** Concise sentence description of the Form and its purpose. */
  description?: string | null;
  /** URL of the Form file */
  file_url: string;
};
export type ReadDepartmentRecordsChannel = {
  /** A concise title for the channel - e.g. "FOIA Portal", "Records Department Phone" */
  title?: string | null;
  /** Single sentence description of the channel and its purpose. */
  description?: string | null;
  /** Tags for record types that can be serviced by this channel.
    e.g. ["crash_reports", "foia_equivalent", "general_records"] */
  services_provided?: ServiceType[] | null;
  /** The type of channel: mail, phone, email, online_portal, fax */
  channel_type?: string | null;
  /** Web sources/citations for this channel information */
  citations?: WebSource[] | null;
  /** Concise instructions on how to request records from the police department, if explicitly mentioned, otherwise null.
    e.g. 'To request a police report, please visit the police department website and fill out the request form.' */
  instructions: string;
  handle: ContactHandleSchema;
  fee_amount?: number | null;
  major_vendor?: PoliceRecordsInquiryMajorVendor;
  /** An explicitly provided link to a pdf, docx, or other static file form that the department publishes and requires
    inquirers to fill out for making police report requests. Not every PD may ask for inquirers to provide a formal request,
    but if they do, we should capture them here - otherwise null. */
  required_document_url?: WebSource;
  mailing_instructions?: CheckMailingInstructions;
  /** Department-provided forms associated with this channel */
  forms?: DepartmentForm[] | null;
  /** Portal URL if this is an online portal channel */
  portal_url?: string | null;
  /** Portal domain if this is an online portal channel */
  portal_domain?: string | null;
  id: string | string;
  created_at: string;
  modified_at: string;
  police_department_id: string | string;
  required_document_file_url?: string | null;
};
export type ReadPoliceDepartment = {
  /** Police department name, if explicitly mentioned, otherwise null */
  name?: string | null;
  /** Police department state, if explicitly mentioned, otherwise null. e.g. 'California' */
  state_name?: string | null;
  /** Police department state code, if explicitly mentioned, otherwise null. e.g. 'CA' */
  state_code?: string | null;
  /** The best available contact methods for the police department for requesting records, documents or reports.
    - NON-EMERGENCY phone lines
    - Any specific 'records' department phone or fax numbers
    - Mailing addresses for records requests
    - Email addresses for records requests
    - Online portals for records requests
    - Department homepage */
  handles?: ContactHandleSchema[] | null;
  /** Primary source provided aliases or abbreviations for the department, e.g. 'SFPD' */
  aliases?: string[] | null;
  /** Ascertained jurisdiction type of the police department / agency, if explicitly
    stated. */
  jurisdiction_type?: JurisdictionType;
  /** Primary source provided name or description of the jurisdiction,
    e.g. 'San Francisco', 'Coffee County, Tennessee', 'Major Highways of Tennessee' */
  jurisdiction_name?: string | null;
  /** system use: Whether the police department has been enriched with additional information */
  enrichment_status?: PoliceDepartmentEnrichmentStatus;
  /** A concise, but comprehensive description of the police department, if explicitly mentioned, otherwise null.
    e.g. 'The San Francisco Police Department is the primary law enforcement agency for the City and County of San Francisco.' */
  description?: string | null;
  records_channels?: ReadDepartmentRecordsChannel[];
  /** The time zone of the police department, if explicitly mentioned, otherwise null.
    e.g. 'America/Los_Angeles' */
  time_zone?: TimeZone;
  /** Flag to mark department as do not call - prevents voice agent outreach */
  do_not_call?: boolean;
  id: string | string;
  created_at: string;
  modified_at: string;
};
export type ReadPoliceReport = {
  /** Guide to attestation statuses:
    
    <inferred>
    The involvement of this department is a system generated guess based on some circumstantial clues, like the location of the incident,
    the department hasn't been directly named anywhere in the case context. Always use this when the department is not
    directly named in the case context.
    </inferred>
    <unclear>
    The department has been named somewhere in the case context, but we have mixed indications as to whether it was involved in the incident.
    </unclear>
    <attested_unverified>
    Secondary source (client intake, staff note) attestation
    that a police report exists with this department.
    </attested_unverified>
    <rejected_verified>
    Primary source (department representative) confirmation that
    a police report does not exist within the department, e.g. 'We do not have a
    report for this incident'
    </rejected_verified>
    <attested_verified>
    Primary source (department representative, or official
    communication) confirmation that the department produced or is producing a report,
    e.g. an officer communication that says 'We are producing a report'
    </attested_verified>
    <verified_received>
    Ulimate confirmation: we have the final police report in hand
    can only be inferred from the matching incident report itself
    </verified_received> */
  attestation_status?: PoliceReportAttestationStatus;
  /** In at most 3 concise sentences, summarize our investigation into this department's involvement,
    critically addressing all three of the following points:
    
    1) How we discovered this department (source & reasoning)
    2) What actions, if any, we've taken to verify involvement
    3) Current understanding and next steps.
    
    Derivative examples:
    INFERRED status:
    "Guessed via location analysis - incident at I-405 & Sunset suggests CHP jurisdiction.
    No additional information yet. Next: call to confirm."
    
    UNCLEAR status:
    "Client mentioned 'LAPD responded' in intake (10/15). Called records dept 3x (10/20, 10/22, 10/25) - conflicting info.
    Officer Smith said 'checking their system and to call back in a few days'.
    Next: Request supervisor callback for definitive answer."
    
    ATTESTED_UNVERIFIED status:
    "Client's intake form states 'SFPD took report at scene, got card from Officer Chen #4521'.
    Found matching Officer Chen in SFPD roster. Called records (11/1) - hold times excessive.
    Next: Submit online records request with officer badge number."
    
    REJECTED_VERIFIED status:
    "Initially suspected due to jurisdiction overlap. Spoke with Records Supervisor Johnson (11/5, recorded).
    Confirmed: 'We did not respond to that location on [date]. Try County Sheriff.'
    Investigation complete for this department. Consider marking inactive."
    
    ATTESTED_VERIFIED status:
    "Department confirmed involvement via email from Records Dept (11/10): 'Report #2024-1234 is being processed.'
    Processing fee paid ($25). Estimated delivery: 7-10 business days.
    Next: Follow up on 11/20 if not received."
    
    VERIFIED_RECEIVED status:
    "Full report was found in case files. 8 pages, includes witness statements and diagram.
    Officer Rodriguez #7823 was primary. Report confirms client's account of events.
    Investigation complete. All documentation uploaded to case file." */
  attestation_description?: string | null;
  /** Attested availability status of the police report, only when explicitly mentioned by a primary source, otherwise null.
    <verified_ready>
    The police department has confirmed that the report is available.
    </verified_ready>
    <verified_pending>
    The police department has confirmed they are responsible for the report, but that the report is not available yet, but will be on some timeline.
    </verified_pending>
    <unknown>
    No explicit mention yet of whether the police department is responsible for the report, or if we have any other information to go on.
    </unknown> */
  availability_status?: PoliceReportAvailabilityStatus;
  /** When availability status is pending, an estimated date for when the police report might be ready, only when explicitly mentioned by a primary source, otherwise null.
    e.g. 'The report is expected to be ready by 11/20' */
  availability_estimate?: string | null;
  /** A concise, but comprehensive description of the police involvement, if explicitly mentioned, otherwise null.
    e.g. 'The police department responded to the incident, took statements from witnesses, spoke to both drivers, etc.' */
  description?: string | null;
  /** Department-issued identifier for the report
    e.g. police report number, TCR number, accident report number, etc. */
  report_identifier?: string | null;
  /** The date of the incident noted on the report, if explicitly defined by a primary source,
    otherwise null. */
  reported_incident_date?: string | null;
  /** Location of the incident, if explicitly mentioned, otherwise null.
    e.g. '123 Main St, San Francisco, CA 94133' */
  reported_location?: string | null;
  /** Officers explicitly mentioned in the text, if explicitly mentioned, otherwise null
    e.g. 'Officer John Doe, Officer Jane Smith, etc.' */
  involved_officers?: OfficerDetail[] | null;
  /** Internal ID of the associated police department - not set during extraction */
  police_department_id?: (string | string) | null;
  /** [system use] The reason this report has been escalated to a human. */
  escalation_reason?: PoliceReportEscalationReason;
  matter_id: string | string;
  id: string | string;
  created_at: string;
  modified_at: string;
  police_department: ReadPoliceDepartment;
};
export type TreatmentRecordRequestActor = "user" | "agent";
export type TreatmentRecordTypes =
  | "Bills"
  | "Records"
  | "Facility Records"
  | "Facility Bills"
  | "Radiology"
  | "ER Physician Bills"
  | "Other"
  | "Unknown";
export type TreatmentRecordRequestStatus =
  | "not_ready"
  | "pending"
  | "request_submitted"
  | "request_received"
  | "awaiting_invoice"
  | "pending_payment"
  | "records_pending"
  | "records_delivered"
  | "records_ingested"
  | "rejected"
  | "cancelled"
  | "auto_retried";
export type Blockers =
  | "HIPAA_PACKAGE_NOT_READY"
  | "CLIENT_INFORMATION_NOT_ENTERED"
  | "PROVIDER_CONTACT_INFORMATION_NOT_ENTERED"
  | "PORTAL_REQUEST_ID_REQUIRED"
  | "NO_REQUEST_SENT_AT"
  | "VOICE_AI_INFORMATION_NOT_ENTERED"
  | "FOLLOWUP_HIPAA_PACKAGE_NOT_SUBMITTED"
  | "FOLLOWUP_CHANNEL_NOT_CONFIGURED"
  | "FOLLOWUP_CHANNEL_UNSUPPORTED"
  | "FOLLOWUP_FAX_NUMBER_MISSING"
  | "FOLLOWUP_EMAIL_ADDRESS_MISSING"
  | "FOLLOWUP_TASK_TERMINAL";
export type TreatmentRecordRequestAutomationBlockedSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "blocked";
  blocked_by?: Blockers[];
};
export type TreatmentRecordRequestAutomationFailedSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "failed";
};
export type TreatmentRecordRequestAutomationIdleSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "idle";
};
export type TreatmentRecordRequestAutomationRunningSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "running";
};
export type TreatmentRecordRequestAutomationSleepingSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "sleeping";
  sleep_until: string;
};
export type PatientInformation = {
  client_name: string;
  client_date_of_birth: string;
};
export type TreatmentRecordRequestChannelType =
  | "portal"
  | "human"
  | "email"
  | "fax"
  | "mail"
  | "phone";
export type RequestDetails = {
  request_method: TreatmentRecordRequestChannelType;
  request_sent_at: string;
  request_method_target: string;
  contact_number: string;
};
export type RequesteeInformation = {
  requestee_name: string;
};
export type VoiceAiCallArgs = {
  patient_information: PatientInformation;
  request_details: RequestDetails;
  requestee_information: RequesteeInformation;
  /** Human-readable description of the requested records (e.g., Medical Records, Bills, Radiology). */
  request_type_label?: string | null;
  /** Skip business-hours scheduling and execute the call immediately. Used for manual/bulk calls that should run ASAP. */
  skip_scheduling_delay?: boolean;
};
export type MrFollowupObservationSchemaVersion = "mr_followup_observation_v1";
export type MrFollowupConnectionOutcome =
  | "HUMAN"
  | "VOICEMAIL"
  | "IVR"
  | "NO_ANSWER"
  | "BUSY"
  | "INVALID_NUMBER"
  | "FAILED"
  | "UNKNOWN";
export type MrFollowupEtaUnit =
  | "HOURS"
  | "DAYS"
  | "WEEKS"
  | "BUSINESS_DAYS"
  | "BUSINESS_HOURS";
export type MrFollowupConnectionFollowupInstructions = {
  details?: string | null;
  eta_value?: number | null;
  eta_unit?: MrFollowupEtaUnit;
  phone?: string | null;
};
export type MrFollowupConnection = {
  outcome: MrFollowupConnectionOutcome;
  attempts_before_connect?: number | null;
  voicemail_left?: boolean | null;
  followup_instructions?: MrFollowupConnectionFollowupInstructions;
};
export type MrFollowupContactOutcome =
  | "WRONG_NUMBER_REDIRECT"
  | "WRONG_PROVIDER"
  | "INFO_INSUFFICIENT"
  | "CALLBACK_REQUESTED"
  | "NOT_FOUND_REDIRECT"
  | "NOT_FOUND_RETRY"
  | "REQUEST_FOUND"
  | "UNKNOWN";
export type MrFollowupRedirectMethod =
  | "FAX"
  | "EMAIL"
  | "PORTAL"
  | "MAIL"
  | "OTHER";
export type MrFollowupContactRedirect = {
  new_phone?: string | null;
  new_destination?: string | null;
  new_destination_method?: MrFollowupRedirectMethod;
};
export type MrFollowupContactCallback = {
  callback_time?: string | null;
  reason?: string | null;
  callback_phone?: string | null;
};
export type MrFollowupContactInfoInsufficient = {
  info_needed?: string | null;
};
export type MrFollowupContact = {
  outcome: MrFollowupContactOutcome;
  department_reached?: string | null;
  representative_name?: string | null;
  redirect?: MrFollowupContactRedirect;
  callback?: MrFollowupContactCallback;
  info_insufficient?: MrFollowupContactInfoInsufficient;
};
export type MrFollowupStatusOutcome =
  | "IN_PROCESSING"
  | "BLOCKED_LETTERHEAD"
  | "BLOCKED_AUTH"
  | "BLOCKED_DOCS"
  | "REJECTED_NOT_PATIENT"
  | "REJECTED_NO_RECORDS"
  | "REJECTED_AFTER_PROCESSING"
  | "RECORDS_READY"
  | "UNKNOWN";
export type MrFollowupInProcessing = {
  eta_value?: number | null;
  eta_unit?: MrFollowupEtaUnit;
  followup_contact_name?: string | null;
  followup_phone?: string | null;
  reference_number?: string | null;
  additional_reference_numbers?: string[] | null;
};
export type MrFollowupBlocked = {
  details?: string | null;
};
export type MrFollowupRejected = {
  details?: string | null;
  representative_name?: string | null;
};
export type MrFollowupStatus = {
  outcome: MrFollowupStatusOutcome;
  in_processing?: MrFollowupInProcessing;
  blocked?: MrFollowupBlocked;
  rejected?: MrFollowupRejected;
};
export type MrFollowupInvoiceOutcome =
  | "NO_INVOICE"
  | "INVOICE_SENT"
  | "INVOICE_PENDING"
  | "INVOICE_UNKNOWN"
  | "UNKNOWN";
export type MrFollowupInvoiceChannel =
  | "FAX"
  | "EMAIL"
  | "MAIL"
  | "PORTAL"
  | "OTHER";
export type MrFollowupInvoice = {
  outcome: MrFollowupInvoiceOutcome;
  amount?: number | null;
  channel?: MrFollowupInvoiceChannel;
  destination?: string | null;
  date_sent?: string | null;
  eta?: string | null;
  invoice_number?: string | null;
};
export type MrFollowupPaymentOutcome =
  | "PAYMENT_ON_CALL"
  | "PAYMENT_OFFLINE_MAIL"
  | "PAYMENT_OFFLINE_ONLINE"
  | "PAYMENT_PENDING"
  | "PAYMENT_CONFIRMED"
  | "UNKNOWN";
export type MrFollowupPayment = {
  outcome?: MrFollowupPaymentOutcome;
  amount_paid?: number | null;
  confirmation_number?: string | null;
  payee_name?: string | null;
  mailing_address?: string | null;
  portal_url?: string | null;
  account_instructions?: string | null;
  date_paid?: string | null;
};
export type MrFollowupDeliveryOutcome =
  | "RECORDS_SENT"
  | "RECORDS_PENDING_DELIVERY"
  | "RECORDS_READY_PICKUP"
  | "UNKNOWN";
export type MrFollowupDeliveryMethod =
  | "FAX"
  | "EMAIL"
  | "PORTAL"
  | "MAIL"
  | "COURIER"
  | "PICKUP"
  | "OTHER";
export type MrFollowupDelivery = {
  outcome?: MrFollowupDeliveryOutcome;
  method?: MrFollowupDeliveryMethod;
  destination?: string | null;
  date_sent?: string | null;
  eta?: string | null;
  portal_url?: string | null;
  access_instructions?: string | null;
  pickup_location?: string | null;
  special_instructions?: string | null;
};
export type AlternateContactHandleType = "fax" | "email" | "mailing_address";
export type AlternateContactSchema = {
  /** Type of contact method (fax/email/mailing address). */
  handle_type: AlternateContactHandleType;
  /** The actual contact value (fax number, email, or mailing address). */
  value: string;
  /** Optional human-readable label or description. */
  label?: string | null;
  /** Optional confidence score from AI extraction (0-1). */
  confidence?: number | null;
};
export type MrFollowupEvidenceEntry = {
  field: string;
  quote: string;
};
export type MrFollowupObservationV1 = {
  schema_version: MrFollowupObservationSchemaVersion;
  summary: string;
  related_reference_numbers?: string[] | null;
  connection: MrFollowupConnection;
  contact?: MrFollowupContact;
  status?: MrFollowupStatus;
  invoice?: MrFollowupInvoice;
  payment?: MrFollowupPayment;
  delivery?: MrFollowupDelivery;
  alternate_contacts?: AlternateContactSchema[];
  evidence: MrFollowupEvidenceEntry[];
};
export type MrFollowupDecisionSchemaVersion = "mr_followup_decision_v1";
export type MrFollowupNextActor = "SYSTEM" | "USER" | "BPO" | "STOP";
export type MrFollowupNextAction =
  | "RETRY_CALL"
  | "WAIT_FOR_CALLBACK"
  | "CALL_BACK_AT_TIME"
  | "CALL_NEW_NUMBER"
  | "RESEARCH_NEW_NUMBER"
  | "RESUBMIT_SAME_DESTINATION"
  | "RESUBMIT_NEW_DESTINATION"
  | "PROVIDE_MISSING_INFO"
  | "PROVIDE_MISSING_DOCS"
  | "VERIFY_PATIENT_INFO"
  | "WAIT_FOR_PROCESSING"
  | "WAIT_FOR_INVOICE"
  | "PAY_INVOICE"
  | "WAIT_FOR_PAYMENT_CONFIRMATION"
  | "CHECK_INBOX_FOR_RECORDS"
  | "WAIT_FOR_RECORDS_DELIVERY"
  | "RETRIEVE_RECORDS"
  | "ESCALATE_TO_BPO"
  | "STOP_NO_ACTION"
  | "STOP_REJECTED";
export type MrFollowupDecisionActionContext = {
  notes?: string | null;
  callback_time?: string | null;
  new_phone?: string | null;
  new_destination?: string | null;
  followup_eta_value?: number | null;
  followup_eta_unit?: MrFollowupEtaUnit;
};
export type MrFollowupDecisionV1 = {
  schema_version: MrFollowupDecisionSchemaVersion;
  next_actor: MrFollowupNextActor;
  next_action: MrFollowupNextAction;
  next_action_at?: string | null;
  required_user_inputs: string[];
  rationale: string;
  action_context?: MrFollowupDecisionActionContext;
};
export type MrFollowupQualitySchemaVersion = "mr_followup_quality_v1";
export type MrFollowupQualityFailureMode =
  | "SCHEMA_VIOLATION"
  | "UNGROUNDED_CLAIMS"
  | "MISCLASSIFIED_OUTCOME"
  | "MISSING_KEY_PRIMITIVE"
  | "BAD_EVIDENCE"
  | "BAD_NEXT_ACTION"
  | "OTHER";
export type MrFollowupQualityV1 = {
  schema_version: MrFollowupQualitySchemaVersion;
  overall_score: number;
  should_trust: boolean;
  notes: string;
  grounding_score: number;
  decision_score: number;
  evidence_score: number;
  primary_failure_mode?: MrFollowupQualityFailureMode;
};
export type ContactDiscoveryCallSummarySchema = {
  /** Short text describing what the facility told us. */
  call_summary: string;
  /** List of submission channels (portal, fax, email) mentioned during the call. */
  submission_methods?: string[];
  /** Documents or prerequisites (HIPAA, ID, invoices) called out by the facility. */
  required_documents?: string[];
  /** Structured alternates (fax numbers, mailing addresses) discovered during the call. */
  alternate_contacts?: AlternateContactSchema[];
  /** Optional free-form notes for additional context. */
  notes?: string | null;
};
export type TransmissionStrategyConfig = {
  enabled?: boolean;
  channel?: TreatmentRecordRequestChannelType;
  interval_days?: number;
  max_attempts?: number;
  stop_on_voice_ai_contact?: boolean;
  stop_on_status_change?: boolean;
  last_transmission_at?: string | null;
  next_transmission_at?: string | null;
  total_transmissions_sent?: number;
  failed_attempts?: number;
};
export type TreatmentRecordRequestMetadataSchema = {
  slack_message_id?: string | null;
  disable_automations?: boolean;
  automation_state_v2?:
    | (
        | ({
            status: "blocked";
          } & TreatmentRecordRequestAutomationBlockedSchema)
        | ({
            status: "failed";
          } & TreatmentRecordRequestAutomationFailedSchema)
        | ({
            status: "idle";
          } & TreatmentRecordRequestAutomationIdleSchema)
        | ({
            status: "running";
          } & TreatmentRecordRequestAutomationRunningSchema)
        | ({
            status: "sleeping";
          } & TreatmentRecordRequestAutomationSleepingSchema)
      )
    | null;
  ad_hoc_voice_ai_args?: VoiceAiCallArgs;
  front_conversation_id?: string | null;
  front_conversation_url?: string | null;
  email_sent_at?: string | null;
  /** Number of days between voice AI follow-up calls */
  voice_ai_check_interval_days?: number;
  next_scheduled_call?: string | null;
  request_submitted_at?: string | null;
  initial_contact_method_call_completed_at?: string | null;
  voice_ai_call_summary?: string | null;
  voice_ai_discovered_alternates?: {
    [key: string]: any;
  }[];
  voice_ai_call_id?: string | null;
  superseded_by_request_id?: string | null;
  supersession_reason?: string | null;
  last_notification_category?: string | null;
  last_notification_subcategory?: string | null;
  last_call_key_information?: {
    [key: string]: any;
  };
  last_voice_ai_call_at?: string | null;
  last_voice_ai_call_summary?: string | null;
  mr_followup_vnext_call_id?: string | null;
  mr_followup_vnext_generated_at?: string | null;
  mr_followup_observation_v1?: MrFollowupObservationV1;
  mr_followup_decision_v1?: MrFollowupDecisionV1;
  mr_followup_quality_v1?: MrFollowupQualityV1;
  mr_followup_vnext_observation_used_audio?: boolean | null;
  mr_followup_vnext_observation_fallback_reason?: string | null;
  mr_followup_vnext_decision_used_audio?: boolean | null;
  mr_followup_vnext_decision_fallback_reason?: string | null;
  mr_followup_vnext_quality_used_audio?: boolean | null;
  mr_followup_vnext_quality_fallback_reason?: string | null;
  dynamic_retry_delay_hours?: number | null;
  contact_discovery_summary?: ContactDiscoveryCallSummarySchema;
  contact_discovery_last_updated_at?: string | null;
  hipaa_package_locked?: boolean;
  hipaa_package_locked_at?: string | null;
  hipaa_package_submission_channel?: TreatmentRecordRequestChannelType;
  hipaa_package_submission_workflow_id?: string | null;
  alternate_contact?: AlternateContactSchema;
  forked_from_request_id?: string | null;
  transmission_strategy?: TransmissionStrategyConfig;
  notes?: string | null;
};
export type TreatmentRecordRequestPortalType =
  | "smart_request"
  | "mro"
  | "chartswap";
export type PortalRecordType = {
  id: string | string;
  created_at: string;
  modified_at: string;
  original_name?: string | null;
  record_type: TreatmentRecordTypes;
};
export type PortalProvider = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name: string;
  portal: TreatmentRecordRequestPortalType;
  active?: boolean;
  external_id?: string | null;
  site?: string | null;
  website?: string | null;
  phone?: string | null;
  email?: string | null;
  fax?: string | null;
  address_line_1?: string | null;
  address_line_2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  record_types?: PortalRecordType[] | null;
};
export type TreatmentRecordRequestChannelSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  type: TreatmentRecordRequestChannelType;
  portal_provider_id?: (string | string) | null;
  phone_number?: string | null;
  address?: string | null;
  email?: string | null;
  fax?: string | null;
  instructions?: string | null;
  portal_record_request_id?: string | null;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_directory_contact_point_id?: (string | string) | null;
  portal_provider?: PortalProvider;
};
export type FaxTransmissionStatusSchema = {
  id?: (string | string) | null;
  status?: ("pending" | "sent" | "delivered" | "failed") | null;
  sent_at?: string | null;
  delivered_at?: string | null;
  failed_at?: string | null;
  transmission_id?: string | null;
  error_message?: string | null;
};
export type EmailTransmissionStatusSchema = {
  sent_at?: string | null;
  front_conversation_id?: string | null;
  front_conversation_url?: string | null;
  recipient_email?: string | null;
};
export type TreatmentRecordRequestSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  provider_id: string | string;
  actor?: TreatmentRecordRequestActor;
  is_certified?: boolean;
  is_urgent?: boolean;
  provided_records?: TreatmentRecordTypes[];
  status?: TreatmentRecordRequestStatus;
  metadata?: TreatmentRecordRequestMetadataSchema;
  channel?: TreatmentRecordRequestChannelSchema;
  fax_transmission_status?: FaxTransmissionStatusSchema;
  email_transmission_status?: EmailTransmissionStatusSchema;
  task_id?: (string | string) | null;
};
export type TaskSchemaForDeliverable = {
  task: TaskWithUpdatesSchema;
  firm: FirmSchema;
  matter: MatterSchemaForDeliverable;
  client: MatterClientSchema;
  coverage?: CoverageSchema;
  provider?: MedicalProviderSchema;
  assignee?: CustomUserSchema;
  police_report?: ReadPoliceReport;
  treatment_record_request?: TreatmentRecordRequestSchema;
};
export type DeliverableAgentContext = {
  /** Single sentence (≤20 words) explaining why this deliverable was created. */
  rationale?: string | null;
};
export type DeliverableMatchStatus = "Needs Review" | "Approved" | "Rejected";
export type DeliverableMatchContext = {
  /** ONE concise sentence explaining the match. Example: 'Document contains signed retainer dated 4/15/2024.' */
  rationale?: string | null;
  /** Up to 3 short, direct quotes supporting the match. Keep each quote under 20 words. */
  key_evidence?: string[] | null;
};
export type ArtifactPrimaryCategory =
  | "Police Report and Evidence"
  | "Insurance Information"
  | "Medical Records"
  | "Bills and Liens"
  | "Client Correspondence"
  | "Unclear";
export type ArtifactDigestSchema = {
  id: string | string;
  artifact_id: string | string;
  title?: string | null;
  brief?: string | null;
  primary_tag?: ArtifactPrimaryCategory;
  secondary_tags?: string[] | null;
  source?: string | null;
  information_score?: number | null;
  work_log_entry?: string | null;
  client_name?: string | null;
  confidence?: number | null;
  long_form_description?: string | null;
  three_line_summary?: string | null;
  one_line_summary?: string | null;
  file_name?: string | null;
  subtitle?: string | null;
  blur_by_default?: boolean | null;
  status?: string | null;
};
export type ConversationSource =
  | "twilio"
  | "dialpad"
  | "bland_ai"
  | "ringcentral";
export type AudioConversationSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name?: string | null;
  start_timestamp?: string | null;
  end_timestamp?: string | null;
  duration?: number | null;
  is_inbound?: boolean | null;
  attorney_number?: string | null;
  client_number?: string | null;
  twilio_number?: string | null;
  twilio_sid_incoming_call?: string | null;
  dialpad_call_id?: string | null;
  ringcentral_call_id?: (string | string) | null;
  source?: ConversationSource;
};
export type TranscriptSchema = {
  id: string | string;
  transcript_path?: string | null;
  conversation?: AudioConversationSchema;
  created_at: string;
  modified_at: string;
};
export type BlobSchema = {
  id: string | string;
  name: string;
  original_filename: string | null;
  collection_id: string | string;
  collection_name: string;
  file_hash: string;
  file_size: number;
  file_extension: string | null;
  file_mime_type: string | null;
  download_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type MessageType =
  | "sms"
  | "mms"
  | "call"
  | "custom"
  | "email"
  | "facebook"
  | "front_chat"
  | "googleplay"
  | "intercom"
  | "internal"
  | "phone-call"
  | "tweet"
  | "tweet_dm"
  | "whatsapp"
  | "yalo_wha"
  | "fax"
  | "mailed_letter"
  | "mailed_cheque";
export type MessageSource =
  | "dialpad"
  | "front"
  | "hellosign_fax"
  | "postgrid"
  | "finch_correspondence"
  | "ringcentral";
export type MessageAttachmentSchema = {
  id: string | string;
  name: string | null;
  content_type: string | null;
  file_size: number | null;
  description: string | null;
  blob: BlobSchema;
};
export type RecipientRole = "from" | "to" | "cc" | "bcc" | "reply_to";
export type BasicRecipientSchema = {
  name?: string | null;
  handle?: string | null;
  role?: RecipientRole;
  external_id?: string | null;
};
export type BasicRecipientBlob = {
  recipients: BasicRecipientSchema[];
};
export type TransmissionStatus =
  | "pending"
  | "queued"
  | "sending"
  | "sent"
  | "delivered"
  | "failed"
  | "bounced"
  | "delivery_failed"
  | "sending_failed"
  | "received";
export type MessageSchema = {
  id: string | string;
  message_type: MessageType;
  content: string | null;
  subject: string | null;
  blurb: string | null;
  text: string | null;
  is_inbound: boolean | null;
  from_number: string | null;
  to_numbers: string[] | null;
  source: MessageSource;
  source_timestamp: string | null;
  created_at: string;
  modified_at: string;
  attachments: MessageAttachmentSchema[];
  recipient_blob?: BasicRecipientBlob;
  transmission_status?: TransmissionStatus;
  transmission_error?: string | null;
  ringcentral_message_id?: (string | string) | null;
};
export type ConversationSchema = {
  id: string | string;
  is_client_sms_conversation: boolean;
  created_at: string;
  modified_at: string;
  messages: MessageSchema[];
};
export type StaffNoteSchema = {
  content: string;
  matter_id: string | string;
  id: string | string;
  user_id: string | string;
  created_at: string;
  modified_at: string;
  agent_tags?: string[];
};
export type DetailedArtifactSchema = {
  id: string | string;
  matter_id: string | string;
  name: string;
  artifact_type: ArtifactType;
  created_at: string;
  modified_at: string;
  extract_from?: boolean;
  artifact_digest?: ArtifactDigestSchema;
  audio_conversation?: AudioConversationSchema;
  transcript?: TranscriptSchema;
  blob?: BlobSchema;
  conversation?: ConversationSchema;
  message?: MessageSchema;
  staff_note?: StaffNoteSchema;
};
export type DeliverableMatchSchema = {
  status?: DeliverableMatchStatus;
  confidence?: number | null;
  context?: DeliverableMatchContext;
  id: string | string;
  deliverable_id: string | string;
  artifact?: DetailedArtifactSchema;
  front_conversation_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
  user_id?: (string | string) | null;
  user_name?: string | null;
  agent?: AgentType;
};
export type DeliverableMatchSchemaRead = {
  status?: DeliverableMatchStatus;
  confidence?: number | null;
  context?: DeliverableMatchContext;
  id: string | string;
  deliverable_id: string | string;
  artifact?: DetailedArtifactSchema;
  front_conversation_id?: (string | string) | null;
  created_at: string;
  modified_at: string;
  user_id?: (string | string) | null;
  user_name?: string | null;
  agent?: AgentType;
  /** Title of the artifact if match is to an artifact. */
  artifact_id: (string | string) | null;
};
export type DeliverableSchema = {
  name: string;
  prompt: string;
  artifact_criteria?: DeliverableArtifactCriteria;
  anchors?: DeliverableAnchors;
  status?: DeliverableStatus;
  id: string | string;
  task: TaskSchemaForDeliverable;
  created_at: string;
  modified_at: string;
  user_id?: (string | string) | null;
  agent?: AgentType;
  agent_context?: DeliverableAgentContext;
  matches?: DeliverableMatchSchema[];
  /** Canonical group of the task (backwards compatibility). */
  task_canonical_group: TaskGroups;
  /** Canonical type of the task (backwards compatibility). */
  task_canonical_type: TaskType;
};
export type DeliverableSchemaRead = {
  name: string;
  prompt: string;
  artifact_criteria?: DeliverableArtifactCriteria;
  anchors?: DeliverableAnchors;
  status?: DeliverableStatus;
  id: string | string;
  task: TaskSchemaForDeliverable;
  created_at: string;
  modified_at: string;
  user_id?: (string | string) | null;
  agent?: AgentType;
  agent_context?: DeliverableAgentContext;
  matches?: DeliverableMatchSchemaRead[];
  /** ID of the task (backwards compatibility). */
  task_id: string | string;
  /** Name of the task (backwards compatibility). */
  task_name: string;
  /** Canonical group of the task (backwards compatibility). */
  task_canonical_group: TaskGroups;
  /** Canonical type of the task (backwards compatibility). */
  task_canonical_type: TaskType;
  /** Number of matches needing review. */
  pending_matches: number;
  /** Number of rejected matches. */
  rejected_matches: number;
  /** Whether completing the parent task requires evidence for this deliverable. */
  requires_evidence?: boolean;
};
export type CreateDeliverable = {
  name: string;
  prompt: string;
  artifact_criteria?: DeliverableArtifactCriteria;
  anchors?: DeliverableAnchors;
  status?: DeliverableStatus;
  task_id: string | string;
};
export type CreateDeliverableMatch = {
  status?: DeliverableMatchStatus;
  confidence?: number | null;
  context?: DeliverableMatchContext;
  deliverable_id: string | string;
  artifact_id?: (string | string) | null;
  front_conversation_id?: (string | string) | null;
};
export type UpdateDeliverableMatch = {
  status?: DeliverableMatchStatus;
  confidence?: number | null;
  context?: DeliverableMatchContext;
  id: string | string;
};
export type UpdateDeliverableMatch2 = {
  status?: DeliverableMatchStatus;
  confidence?: number | null;
  context?: DeliverableMatchContext;
  id: string | string;
};
export type UpdateDeliverableStatus = {
  status: DeliverableStatus;
};
export type UpdateDeliverableStatus2 = {
  status: DeliverableStatus;
};
export const {
  useMatterDeliverablesListQuery,
  useMatterDeliverablesRetrieveQuery,
  useMatterDeliverablesBatchCreateMutation,
  useMatterDeliverablesPendingQuery,
  useMatterDeliverablesScanMutation,
  useMatterDeliverablesScanStatusQuery,
  useMatterDeliverablesSummaryQuery,
  useTaskDeliverablesListQuery,
  useTaskDeliverablesCreateMutation,
  useDeliverableMatchesListQuery,
  useDeliverableMatchesCreateMutation,
  useDeliverableMatchesRetrieveQuery,
  useDeliverableMatchesUpdateMutation,
  useDeliverableMatchesPartialUpdateMutation,
  useDeliverableMatchesDestroyMutation,
  useDeliverableMatchesApproveMutation,
  useDeliverableMatchesRejectMutation,
  useTaskDeliverablesRetrieveQuery,
  useTaskDeliverablesUpdateMutation,
  useTaskDeliverablesPartialUpdateMutation,
  useTaskDeliverablesDestroyMutation,
  useTaskDeliverablesBypassMutation,
  useTaskDeliverablesSummaryQuery,
} = injectedRtkApi;
